import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { formLabelStyling } from 'components/forms/new/formStyles';
import { stackSpacing, stackStyling } from 'components/forms/new/formStyles';

const DefaultAddress = ({
    darkMode,
    addresses,
    errors,
    isFetchingAddresses,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = useCompanyForm();

    const handleSelectChange = (item) => {
        const selectedId = item?.id;
        updateFormData('primaryAddressID', selectedId);
    };

    const hasError = !!errors?.primaryAddressID;

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Default Address
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={DropDown}
                        id="primaryAddressID"
                        name="primaryAddressID"
                        data={addresses}
                        shownValue="description"
                        currentId={formData?.primaryAddressID}
                        selectedId="id"
                        placeholder="Select default address"
                        handleSelectChange={handleSelectChange}
                        width="100%"
                        isLoading={isFetchingAddresses}
                        darkMode={darkMode}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select the default address for this company"
                        ariaLabel="default-address-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default DefaultAddress;
